import { Controller } from "stimulus";

export default class extends Controller {
    static targets = [ 'field', 'gcpId', 'address', 'name'  ];
    searchKeys = [ 'formatted_address', 'name', 'place_id' ];

    connect() {
        if (typeof(google) != "undefined") {
            this.initSearch();
        }
    }

    initSearch() {
        this.autocomplete = new google.maps.places.Autocomplete(this.fieldTarget);
        this.autocomplete.setFields(['place_id', 'formatted_address', 'name', 'geometry']);
        this.autocomplete.setComponentRestrictions({'country': 'ca'});
        // this.autocomplete.setTypes(['address']);

        this.autocomplete.addListener('place_changed', this.placeChanged.bind(this));
        this.element.addEventListener('submit', (e) => e.preventDefault(), true);
    }

    placeChanged() {
        let place = this.autocomplete.getPlace();

        let hasKeys = true;
        this.searchKeys.forEach((val) => {
            if (!(val in place)) {
                hasKeys = false;
            }
        });

        if (hasKeys) {
            // if it's a proper autocompleted address.
            this.gcpIdTarget.value = 'abc';

            this.gcpIdTarget.value = place['place_id'];
            this.addressTarget.value = place['formatted_address'];
            this.nameTarget.value = place['name'];

            this.element.submit();
        } else {
            // if it only contains 'name', it's a user specified address.
            if (!('name' in place)) { throw 'Invalid search query'; } // actually make sure name is there.

            // perform a search for the query.
            let waterloo = new google.maps.LatLng(43.466667, -80.516670);

            let map = new google.maps.Map(document.getElementById('hidden-map'));
            let searchService = new google.maps.places.PlacesService(map);

            let req = {
                query: place['name'],
                fields: ['place_id', 'formatted_address', 'name', 'geometry'],
                locationBias: waterloo
            };

            searchService.findPlaceFromQuery(req, (res, status) => {
                if (res.length < 1) { throw 'No search results found'; }
                this.gcpIdTarget.value = res[0]['place_id'];
                this.addressTarget.value = res[0]['formatted_address'];
                this.nameTarget.value = res[0]['name'];

                this.element.submit();
            });
        }

    }
}
